class CartUpsell extends HTMLElement {
  constructor() {
    super();
  }
}
if (!customElements.get('cart-upsell')) {
  customElements.define('cart-upsell', CartUpsell);
}

class CartUpsellButton extends HTMLElement {
  constructor() {
    super();

    this.select = this.querySelector('select');
    this.button = this.querySelector('button');
    this.price = this.querySelector('[data-price]');

    // named handlers so we can add/remove only once
    this._onSelectPrice = (e) => {
      const sel = e.target || this.select;
      if (this.price && sel?.options && sel.selectedIndex >= 0) {
        this.price.textContent = sel.options[sel.selectedIndex].dataset.price;
      }
    };

    this._onSelectAdd = (e) => {
      const value = e?.target?.value;
      if (value != null) this.addToCart(Number(value));
    };

    this._selectAddBound = false;

    // price updater — safe to add once
    this.select?.addEventListener('change', (e) => {
      this._onSelectPrice(e);
      this.select.classList.toggle('visibility-hidden');
      e.target.focus();
    });

    this.button?.addEventListener('click', () => {
      let variantId = Number(this.button.dataset.variantId);
      if (this.select) {
        this.select.classList.toggle('visibility-hidden');

        // only attach the add-to-cart handler once
        if (!this._selectAddBound) {
          this.select.addEventListener('change', this._onSelectAdd);
          this._selectAddBound = true;
        }
      } else {
        this.addToCart(variantId);
      }
    });
  }

  async addToCart(variantId) {
    if (!variantId) return;
    const formData = {
      items: [{ id: Number(variantId), quantity: 1 }]
    };

    // console.log('Adding to cart:', { variantId, formData });
    this.button.classList.add('loading');
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      const data = await response.json();
      // console.log('Added to cart:', { response, data });

      if (response.ok) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-upsell',
          productVariantId: variantId,
          cartData: data,
        });
        this.button.classList.remove('loading');
        this.button.classList.add('added');

        setTimeout(() => {
          this.button.classList.remove('added');
        }, 1000);

        setTimeout(() => {
          location.reload();
        }, 1000);
      } else {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'cart-upsell',
          productVariantId: variantId,
          errors: data?.errors || data?.description,
          message: data?.message || 'Add to cart failed',
        });

        this.button.classList.remove('loading');
      }
    } catch (err) {
      publish(PUB_SUB_EVENTS.cartError, {
        source: 'cart-upsell',
        productVariantId: variantId,
        errors: err?.errors || err?.description,
        message: err?.message,
      });

      this.button.classList.remove('loading');
    }
  }
}
if (!customElements.get('cart-upsell-button')) {
  customElements.define('cart-upsell-button', CartUpsellButton);
}